import { sideBySideCompare } from '../lib/sideBySideCompare';

export function initWowPage() {
  const compareElements = document.querySelectorAll('.side-by-side-compare');
  compareElements.forEach((el) => sideBySideCompare(el));

  console.log('📄 Wow page initialized.');
}
